<template>
  <el-dialog 
    :class="$style['call-notice']"
    :visible="dialogVisible" 
    :append-to-body="true" 
    v-loading="loading" 
    title="" 
    width="500px"
    @close="cancel">
    <h3>提示</h3>
    
    <p>点击确认后该委托单将发送短信提醒客户缴费</p>
    <!-- <el-popover
      ref="popover"
      placement="bottom"
      title="标题"
      width="200"
      trigger="click"
      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
    </el-popover>

    <el-button v-popover:popover type="text" style=" margin:0 20px;">点击查看短信内容</el-button> -->

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: 'call-notice-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    billId: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      loading:false
    }
  },
  watch: {
  
  },
  methods: {
    submit(){
      this.loading = true
      let data = {
        id: this.billId,
      }
      this.$store.dispatch('callNotice', data).then(res => {
        this.$message.success('催缴成功')
        this.$emit('reload')
        this.cancel()
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(()=>{
        this.loading = false
      })
    },
    cancel () {
      this.$emit('close')
    },
  }
}
</script>
<style module lang="less">
.call-notice{
  :global{
    .el-dialog__body{
      padding: 0;
      text-align: center;
    }
  }
}
</style>
